import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '@workflow/ecp-shared/service/user/user.service';
import { RoutingUrl } from '@shared/constant/route-const';
import { Subscription } from 'rxjs';
import { LoanEventData } from './widget/events/event-data.type';
import { WorkflowWidgetEventNames } from './widget/events/events.enums';
import { WorkflowWidgetEventServiceService } from './widget/workflow-widget-event.service';
import { TokenService } from '@cudirect/shared-ui-library';

@Component({
  selector: 'cu-workflow-wrapper',
  templateUrl: './workflow.component.html'
})
export class WorkflowComponent implements OnDestroy {
  customConfig = {
    loginInfo: {
      hasRegistration: true,
      registrationUrl: 'user/light-registration'
    },
    pagesInfo: {
      skipEligibility: false, // check and set dynamic value here
      skipReferral: false
    }
  };
  subscription: Subscription;
  constructor(
    private readonly workflowEvent: WorkflowWidgetEventServiceService,
    router: Router,
    private readonly tokenService: TokenService,
    private userService: UserService
  ) {
    /** workFlow event subscription moved to app.component */
    /** since we are not using this component to render workflow */
    this.subscription = this.workflowEvent.workflowEvents$.subscribe((t: { name: WorkflowWidgetEventNames; data: LoanEventData }) => {
      if (t.name === WorkflowWidgetEventNames.ApplicationSubmit) {
        if (!this.userService.isAuthenticated) {
          const cachedToken = this.tokenService.getCachedToken();
          if (cachedToken) {
            const tokenType = this.tokenService.determineTokenType();
            if (tokenType === 'arcDX') {
              this.setFirstTimeLogin();
              router.navigate([RoutingUrl.OAO.Overview], { fragment: 'contact-us' });
              return;
            }
          }

          router.navigate(['user/verify']);
        } else {
          this.setFirstTimeLogin();
          router.navigate([RoutingUrl.OAO.Overview], { fragment: 'contact-us' });
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private setFirstTimeLogin(): void {
    const userInfo = this.userService.user;
    userInfo.firstTimeLogin = true;
    this.userService.user = userInfo;
  }
}
